"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_BASE = "/image/new-version/ValueAddedSolutions/On-Demand-Manufacturing/WhyChoose";

const CARDS = [
	{
		keyPrefix: "whyChooseCard1",
		image: `${IMAGE_BASE}/why-choose-us-high-quality parts.jpg`,
		panelClassName: "bg-black",
	},
	{
		keyPrefix: "whyChooseCard2",
		image: `${IMAGE_BASE}/why-choose-us-fast-lead-time.jpg`,
		panelClassName: "bg-[#2f8f2f]",
	},
	{
		keyPrefix: "whyChooseCard3",
		image: `${IMAGE_BASE}/why-choose-us-engineering-support.jpg`,
		panelClassName: "bg-[#a8cf86]",
	},
] as const;

export default function OnDemandWhyChoose() {
	const t = useTranslations("new-on-demand-manufacturing");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("whyChooseTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("whyChooseDesc")}</p>
				</header>

				<div className="grid gap-6 md:grid-cols-3 md:gap-8">
					{CARDS.map((card) => (
						<article key={card.keyPrefix} className="group flex flex-col overflow-hidden bg-white">
							<div className="relative aspect-[16/9] w-full overflow-hidden bg-[#f5f7fa]">
								<Image
									src={card.image}
									alt={t(`${card.keyPrefix}ImageAlt`)}
									fill
									className="object-cover transition-transform duration-300 group-hover:scale-105"
									sizes="(max-width: 768px) 100vw, 33vw"
								/>
							</div>
							<div className={`flex flex-1 flex-col p-6 text-white sm:p-7 ${card.panelClassName}`}>
								<p className="mb-3 text-sm font-semibold text-themePrimary400">
									{t(`${card.keyPrefix}Number`)}
								</p>
								<h3 className="mb-3 text-lg font-bold sm:text-xl md:text-2xl">
									{t(`${card.keyPrefix}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-white/90 md:text-base">
									{t(`${card.keyPrefix}Desc`)}
								</p>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
